<!--
트래킹검수 > 스캔 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-height-1-1 uk-flex uk-flex-column" @click="focus">
        <div class="uk-margin-auto-vertical uk-text-center">

            <div class="header">
                <i class="material-icons">
                    aspect_ratio
                </i>
                검수할 트래킹 BOX를 스캔하세요
            </div>

            <input
                type="text"
                class="scan-input"
                ref="scan"
                placeholder="TRACKING SCAN, HERE (최소 5자리)"
                autofocus
                @keyup.enter="scan"
            />

            <div class="uk-text-primary uk-text-large3">
                {{ scanNo }}
            </div>

            <!-- has not found 경고문구 -->
            <div class="has-not-found" v-show="hasNotFound" slot="alert">
                <div class="uk-margin-small-bottom">
                    입력한 트래킹번호를 찾을 수 없습니다.
                </div>
                <div class="uk-text-danger uk-margin-small-bottom">
                    무자료 처리하세요
                </div>


                <div class="uk-margin-small-bottom" v-if="shipIn">
                    입고일 : {{ shipIn.created_at }} (
                    <b class="uk-text-large3">{{ shipIn.over_days_msg }}</b>)
                </div>

                <!-- 미국은 전체무자료 메뉴가 별도로 있음 -->
                <div class="" v-if="regionCode !== 2">
                    <button
                        class="uk-button uk-button-primary uk-button-large"
                        @click="$parent.showNodata"
                    >
                        <i class="material-icons">edit</i>
                        무자료 등록하기
                    </button>
                </div>
            </div>

            <!-- 입력검증 메세지 -->
            <div class="empty-input" v-show="isEmptyScan">
                입력된 값이 없습니다
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        // csrf-token
        csrfToken: String,

        /**
         * 지역id
         */
        regionId: {
            type: Number,
            default: null,
        },

        /**
         * 지역코드
         * (미국 커스텀때문에 추가됨)
         * 1 : 일본
         * 2 : 미국
         * 3 : 중국항공
         * 4 : 중국해상
         * 5 : 영국
         * 6 : 독일
         * 7 : 호주
         **/
        regionCode: {
            type: Number,
            default: null,
        },

        /**
         * 스캔한 트래킹번호
         */
        scanNo: {
            type: String,
            default: null,
        },

        /**
         * 트래킹 자료조회 실패
         */
        hasNotFound: {
            type: Boolean,
            default: false,
        },

        /**
         * 입고정보
         */
        shipIn: {
            type: Object,
            default: null,
        },


    },
    data: function () {
        return {
            // (bool) 빈값을 엔터쳤을때 경고문구 출력여부
            isEmptyScan: false,


        };
    },
    computed: {},
    mounted: function () {
    },

    methods: {
        /**
         * 스캔 input 에 포커스를 줌
         */
        focus: function () {
            this.$refs.scan.focus();
        },

        /**
         * 주어진 번호로 강제 스캔처리
         * @param scan_no (string) 스캔번호
         */
        scanForce: function (scan_no) {
            this.$refs.scan.value = scan_no;
            this.scan();
        },

        /**
         * 스캔처리
         */
        scan: function () {
            let scan_no = this.$refs.scan.value;


            // 검증
            this.isEmptyScan = !scan_no;
            if (this.isEmptyScan) {
                return;
            }


            /**
             * 입력한 값으로 트래킹 조회
             */
            let load = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/regions/' + this.regionId + '/trackings',
                    contentType: 'application/json',
                    data: {
                        scan_no,
                    },
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            });


            // promise 처리
            load.then((response) => {
                // 조회
                let ship_in = response.ship_in;
                let trackings = response.trackings;
                let select_no = response.select_no;
                let selected_index = response.selected_index;

                // 스캔결과 이벤트 발생
                let scan = {
                    scan_no,
                    ship_in,
                    trackings,
                    selected_index
                };
                this.$emit('update:scan', scan);

                // input 초기화
                this.$refs.scan.value = null;
            });


        },
    },
}
</script>

<style lang="scss" scoped>
.header {
    font-size: 1.5rem;
    .material-icons {
        font-size: 2rem;
    }
}

.scan-input {
    font-size: 1.25rem;
    height: 6rem;
    width: 80%;
    margin: 3rem 0;
    text-align: center;

}

.has-not-found {
    font-size: 1.5rem;
}
.empty-input {
    font-size: 1.5rem;
    color: #ff0000;
}
</style>